/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ScholarshipFileApprovalStudentListViewModel } from "../types/ScholarshipFileApprovalStudentListViewModel.ts";
import { scholarshipFileApprovalStudentViewModelSchema } from "./scholarshipFileApprovalStudentViewModelSchema.ts";

export const scholarshipFileApprovalStudentListViewModelSchema = z.object({
  students: z
    .array(z.lazy(() => scholarshipFileApprovalStudentViewModelSchema))
    .describe(
      "Alunos encontrados, ordenados pela data do anexo mais recente (do mais novo para o mais antigo).",
    )
    .nullish(),
  total: z.optional(
    z.number().int().describe("Quantidade de alunos encontrados."),
  ),
  autoLoadCourseFinancialPersonId: z
    .number()
    .int()
    .describe(
      "ID do plano financeiro cujo dossiê deve ser carregado automaticamente. Preenchido apenas quando há exatamente um aluno. Opcional.",
    )
    .nullish(),
}) as unknown as ToZod<ScholarshipFileApprovalStudentListViewModel>;
